import type SchemeQuoteResult from '../SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '@/converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '@/services/enums/DLDCommonValuesEnum'
import QuoteDetails from '../QuoteDetails'

@JsonObject('DynamicQuoteDetails')
export default class DynamicQuoteDetails extends QuoteDetails<SchemeQuoteResult> {
}

@JsonObject('DynamicRenewalQuoteDetails')
export class DynamicRenewalQuoteDetails extends DynamicQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}
